'use client';

import Contentlet from '@/components/shared/contentlet';
import Reviews from '../../reviews';

function NormalizedCard({ data, contenttype, priority = false }) {
    let content;

    switch (contenttype) {
        case 'Reviews':
            content = (
                <Contentlet contentlet={data.originalContentlet}>
                    <Reviews
                        nameOfPerson={data.nameOfPerson}
                        titleOfPerson={data.titleOfPerson}
                        personLogo={data.personLogo}
                        companyLogo={data.companyLogo}
                        quote={data.quote}
                        priority={priority}
                    />
                </Contentlet>
            );
            break;
        default:
            content = null;
    }

    return content;
}

export const CollectionMosaicCard = ({
    contentlet,
    contenttype,
    priority = false,
    deviceType = 'desktop'
}) => {
    const normalizedData = normalizeContentletData(contentlet, contenttype, deviceType);
    return (
        <NormalizedCard
            data={normalizedData}
            contenttype={contenttype}
            priority={priority}
            deviceType={deviceType}
        />
    );
};

const normalizeContentletData = (contentlet, contenttype, deviceType) => {
    let normalizedData = {
        originalContentlet: contentlet,
        nameOfPerson: '',
        titleOfPerson: '',
        personLogo: '',
        companyLogo: '',
        quote: ''
    };

    switch (contenttype) {
        case 'Reviews':
            normalizedData = {
                ...normalizedData,
                nameOfPerson: contentlet.nameOfPerson,
                titleOfPerson: contentlet.titleOfPerson,
                personLogo: contentlet.personLogo,
                companyLogo: contentlet.companyLogo,
                quote: contentlet.quote,
                deviceType: deviceType
            };
            break;
        default:
            break;
    }

    return normalizedData;
};
